import React from 'react';

const MonumentPreview = React.memo(({ text, stoneColor, textColor, fontSize, language }) => {
  const fontClass = language?.fontClass || 'font-hebrew';
  // Real granite textures - user's monument materials
  const graniteTextures = {
    'absolute-black':
      'https://customer-assets.emergentagent.com/job_jewish-monument-type/artifacts/3tfzustt_Absolute%20Black%20.avif',
    grey:
      'https://images.unsplash.com/photo-1764021995962-53921e9f2317?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwyfHxncmV5JTIwZ3Jhbml0ZSUyMHN0b25lJTIwdGV4dHVyZSUyMHBvbGlzaGVkfGVufDB8fHx8MTc3NzE4MjY2NXww&ixlib=rb-4.1.0&q=85',
    'everlasting-blue':
      'https://customer-assets.emergentagent.com/job_jewish-monument-type/artifacts/89sc95b9_Everlasting%20Blue%20.avif',
    'morning-rose':
      'https://customer-assets.emergentagent.com/job_jewish-monument-type/artifacts/pszan0qo_MorningRose.avif',
    'salisbury-pink':
      'https://customer-assets.emergentagent.com/job_jewish-monument-type/artifacts/4avy52tc_Salisbury%20Pink%20.avif',
  };

  const textColors = {
    black: '#1a1a1a',
    gold: '#CA8A04',
    silver: '#94a3b8',
    white: '#f5f5f5',
  };

  const textStyle = {
    color: textColors[textColor] || textColors.black,
    fontSize: `${fontSize}px`,
    textShadow:
      textColor === 'white' || textColor === 'silver'
        ? '2px 2px 6px rgba(0,0,0,0.95), 1px 1px 3px rgba(0,0,0,0.8), -1px -1px 2px rgba(255,255,255,0.1)'
        : '2px 2px 6px rgba(0,0,0,0.7), 1px 1px 3px rgba(0,0,0,0.5), -1px -1px 1px rgba(255,255,255,0.3)',
    fontWeight: 500,
  };

  return (
    <div
      className="monument-preview overflow-hidden border border-stone-900/20 rounded-sm"
      data-testid="monument-preview"
    >
      <div
        className="relative w-full aspect-[4/3] sm:aspect-[16/10] flex items-start justify-center pt-16 sm:pt-20 px-8"
        style={{
          backgroundImage: `url(${graniteTextures[stoneColor] || graniteTextures['absolute-black']})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
        id="monument-preview-content"
        data-granite-url={
          graniteTextures[stoneColor] || graniteTextures['absolute-black']
        }
      >
        <div className="relative z-10 w-full max-w-2xl">
          {text ? (
            <div
              className={`${fontClass} leading-relaxed whitespace-pre-wrap text-center`}
              style={textStyle}
              dir="rtl"
              data-testid="preview-text"
            >
              {text}
            </div>
          ) : (
            <div className="text-center text-stone-300/80 font-spectral font-light text-2xl tracking-tight">
              Your inscription will appear here
            </div>
          )}
        </div>
      </div>
    </div>
  );
});

MonumentPreview.displayName = 'MonumentPreview';

export default MonumentPreview;
